import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { Provider } from 'react-redux';
import watch from 'redux-watch';
import { ConnectedRouter } from 'connected-react-router';

import App from './App';
import configureStore, { history } from './redux/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'nprogress/nprogress.css';
import './index.css';
import './datetime.css';

const store = configureStore();

store.subscribe(
  watch(
    store.getState,
    'newOffer'
  )((newVal: object, oldVal: object, objectPath: string) => {
    try {
      const serializedState = JSON.stringify(newVal);
      localStorage.setItem('currentOffer', serializedState);
    } catch (error) {
      alert("Can't save offer");
    }
  })
);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

$('.mobile-message').css('display', 'block');

if (/Android [4-6]/.test(navigator.appVersion)) {
  window.addEventListener('resize', function () {
    if (
      document.activeElement!.tagName === 'INPUT' ||
      document.activeElement!.tagName === 'TEXTAREA'
    ) {
      window.setTimeout(function () {
        //document.activeElement!.scrollIntoViewIfNeeded();
      }, 0);
    }
  });
}
